































import { snakeCase } from 'lodash'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'

import { SelectOption } from '../../../../../../../../../../logic/types'
import { UseFields } from '../../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../../Pi/types'
import CreateNewLabel from '../../../../../../../components/CreateNewLabel.vue'
import { AddLabelAction } from '../../../logic/Actions/LabelsAction/LabelsAction'
import { LabelsActionProxy } from '../../../logic/Actions/LabelsAction/LabelsActionProxy'
import { systemLabelKey, SYSTEM_LABELS } from '../../../logic/Actions/LabelsAction/SYSTEM_LABELS'

@Component({
  components: {
    CreateNewLabel
  },
  data() {
    return {
      snakeCase,
    }
  }
})
export default class LabelsAction extends Mixins(UseFields) {
  @Prop() proxyAction!: LabelsActionProxy

  @Prop() labels!: () => { [key: number]: string }

  @Prop() createNewLabel!: (label: string) => Promise<{ index: number }>

  @Watch('label_index')
  labelIndexWatcher(): void {
    this.getOptions()
  }

  isLabelModalOpen = false

  labelOptions: Array<SelectOptionData> = []

  initLabelName = ''

  chipsTemplate = 0

  onCreate({ id }: { id: number }) {
    this.proxyAction.setLabels([
      ...this.proxyAction.action.label_index,
      id,
    ])

    this.getOptions()
  }

  getOptions(): void {
    if (this.proxyAction.action instanceof AddLabelAction) {
      this.labelOptions.push(...
        Object.entries(SYSTEM_LABELS)
          .filter(([ _, v ]) => v === SYSTEM_LABELS.BOT_USER_FLAG_CUSTOMER || v === SYSTEM_LABELS.BOT_USER_FLAG_POTENTIAL_CUSTOMER)
        .map(([ k, v ]) => ({ label: this.$t(systemLabelKey(k as keyof typeof SYSTEM_LABELS)).toString(), value: v })))
    }

    this.labelOptions.push(...Object.entries(this.labels()).map(([ id, label ]) => ({ label, value: Number(id) })))
    this.chipsTemplate++
  }

  setLabel(arg: FieldData): FieldData {
    arg.setter = (val) => this.proxyAction.setLabels(val)
    return arg
  }

  prepareCreateNewLabel(option: Pick<SelectOption, 'label'>) {
    this.initLabelName = option.label

    this.isLabelModalOpen = true
  }

  mounted(): void {
    this.getOptions()
  }
}
